// extracted by mini-css-extract-plugin
export default {"propertySeparator":"PropertySeparator_propertySeparator__3t7q1","bigMargin":"PropertySeparator_bigMargin__97Shx"};